import * as React from 'react'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import MenuIcon from '@mui/icons-material/Menu';
import LogoCropped from '../images/LC-Autofit-Logo_cropped.png';
import MTXLogo from '../images/MTXQ1.png';

const NavBar = () => {
    const login_buttons = () => {
        if (document.getElementById('signed-in-identifier').dataset.signedin === "true")
            return <Button href="/users/sign_out" color="inherit"
            //style={{marginLeft: 'auto'}}
            >Sign Out</Button>
        //return <Button href="/users/sign_in" color="inherit" style={{marginLeft: 'auto'}}>Login</Button>
    }
    const isSignedIn = document.getElementById('signed-in-identifier').dataset.signedin === "true";
    console.log("SIGNED", isSignedIn)

    return (
        <Box sx={{ flexGrow: 1, marginBottom: '0.5rem' }}>
            <AppBar position="static" style={{ margin: 0, background: '#F8F8F8', color: 'grey', minHeight: 0 }} >
                <Toolbar style={{ minHeight: 0, padding: '5px' }}>
                    <Button
                        href="/"
                    >
                        <Box
                            component="img"
                            sx={{
                                height: 64,
                            }}
                            alt="LC-Autofit Logo"
                            src={LogoCropped}
                            style={{ height: '25px', margin: '5px 25px 0 0' }}
                        />
                    </Button>
                    {/* {login_buttons()} */}
                    <Button href="/kit_registrations"
                        style={{ color: 'black', fontSize: '1rem' }}
                    >Projects</Button>
                    {/* <Button href="/submissions/new" color="inherit">+ Add Data Files</Button> */}
                    {/* <Button color="inherit">Contact Us</Button> */}
                    <div style={{ marginLeft: 'auto' }}>
                        {isSignedIn && (
                            <Button href="/users/sign_out"
                                style={{ fontSize: '1rem' }}>Sign Out</Button>
                        )}



                        <Button
                            href="https://metabolomix.ca" target="_blank"
                        >
                            <Box
                                component="img"
                                sx={{
                                    height: 64,
                                }}
                                alt="MTX Logo"
                                src={MTXLogo}
                                style={{ height: '34px', margin: '5px 0px 0 25px' }}
                            />
                        </Button>
                    </div>
                </Toolbar>
            </AppBar>
        </Box>
    )
}

export default NavBar